import React from 'react';
import FormLabel from '../Base';
import Wrapper from './style';
const Index = (props) => {
  return <FormLabel {...props} Wrapper={Wrapper} />;
};

export default Index;
